import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_ACC003_Request,
  IAPI_ACC003_Response,
} from "../../../type/apiType";

// 法人ユーザ一覧参照
const httpAPI_ACC003 = async (
  param: IAPI_ACC003_Request
): Promise<IAPI_ACC003_Response> => {
  let res = await http.post(ApiUrl.API_ACC003, {
    ...param,
  });

  return res.data;
};

export { httpAPI_ACC003 };
